import { Text } from '@vkontakte/vkui';
import React, { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import { sendXray } from 'reactApp/utils/ga';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './DuplicatesEmptyState.css';

const text = {
    title: 'Дубликатов пока нет',
    description1: 'Здесь будут все\u00A0одинаковые',
    description2: 'или\u00A0очень\u00A0похожие фото',
};

export const DuplicatesEmptyState = memo(function DuplicatesEmptyState() {
    const isDark = useSelector(isCurrentDarkTheme);
    const imgSrc = `${cdnPackagesUrl}/static/cloud/empty/duplicates${isDark ? '_dark' : ''}.png`;

    useEffect(() => {
        sendXray(['dp-empty-state', '1', 'show']);

        sendPaymentGa({
            eventCategory: ECategoryGa.duplicates,
            action: 'empty-state-show',
            empty_state_type: 'common',
        });
    }, []);

    return (
        <div className={styles.wrapper} data-qa-id="duplicates-empty">
            <div className={styles.container}>
                <img src={imgSrc} className={styles.img} alt="" />
                <div className={styles.textContainer}>
                    <span className={styles.title}>{text.title}</span>
                    <Text className={styles.text}>
                        {text.description1}
                        <br />
                        {text.description2}
                    </Text>
                </div>
            </div>
        </div>
    );
});
